export const ADD_CONTACT_US = "ADD_CONTACT_US";
export const ADD_CONTACT_US_SUCCESS = "ADD_CONTACT_US_SUCCESS";
export const ADD_CONTACT_US_FAILURE = "ADD_CONTACT_US_FAILURE";
export const RESET_CONTACT_US = "RESET_CONTACT_US";

export interface ContactUsState {
  contactUsSuccess: string | null;
  contactUsError: string | null;
  contactUsLoading: boolean;
}

interface AddContactUsAction {
  type: typeof ADD_CONTACT_US;
  payload: any;
}

interface AddContactUsSucess {
  type: typeof ADD_CONTACT_US_SUCCESS;
  payload: any;
}

interface AddContactUsFailure {
  type: typeof ADD_CONTACT_US_FAILURE;
  payload: string;
}

interface ResetContactUsAction {
  type: typeof RESET_CONTACT_US;
}

export type ContactUsActionTypes =
  | AddContactUsAction
  | AddContactUsSucess
  | AddContactUsFailure
  | ResetContactUsAction;
